export default __webpack_public_path__ + "ch-offers.icon-5aae7edf9e83d60f966051fb6815439f.png";